import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import classnames from 'classnames';
import { SkeletonAnimation, SkeletonVariant } from '../../enums';
import styles from './Skeleton.module.scss';
const Skeleton = forwardRef(({ animation = SkeletonAnimation.None, className, height, variant = SkeletonVariant.Text, width, }, ref) => {
    return (_jsx("div", { ref: ref, className: classnames(styles.skeleton, styles[variant], {
            [styles[animation]]: animation !== 'none',
        }, className), style: {
            width,
            height,
        } }));
});
Skeleton.displayName = Skeleton.name;
export { Skeleton };
